(function () {

    document.addEventListener('DOMContentLoaded', function () {

        // Event listener para el botón de envío
        document.getElementById('submitBtnRegistroB2c').addEventListener('click', enviarFormularioRegistroB2c);

    });

    function enviarFormularioRegistroB2c() {
        (async () => {

            const formData = new FormData();

            // Recuperar los valores de nombre, apellidos y correo electrónico
            const nombre = document.getElementById('RegisterForm-FirstName');
            const apellidos = document.getElementById('RegisterForm-LastName');
            const email = document.getElementById('RegisterForm-email');
            const passwordInput = document.getElementById('RegisterForm-password');

            //Se verifican los campos para que no se produzca el caso en el que quede el usuario registrado en el ERP y no en Shopify.
            // Verificar si el nombre y apellidos están llenos
            if (nombre.value.trim() === '' || apellidos.value.trim() === '') {
                return;
            }

            // Verificar si el email es válido
            if (!isValidEmail(email.value)) {
                return;
            }

            // Verificar si la contraseña tiene al menos 6 caracteres
            if (passwordInput.value.length < 4) {
                return;
            }


            // Agregar al objeto FormData
            formData.append('nombre', nombre.value);
            formData.append('apellidos', apellidos.value);
            formData.append('email', email.value);
            formData.append('shop', shop);

            const plainFormData = Object.fromEntries(formData.entries());
            const formDataJsonString = JSON.stringify(plainFormData);
            console.log('json: ' + formDataJsonString);

            const fetchOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: formDataJsonString
            };

            fetch('/apps/upango_registrar_b2b/customers/create', fetchOptions)
                .then(response => {
                    if (response.ok) {
                        // Si la respuesta es exitosa, muestra un mensaje
                        console.log('La solicitud se procesó correctamente.');
                    } else {
                        // Si la respuesta no es exitosa, muestra un mensaje de error
                        console.error('Error en la respuesta:', response.statusText);
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    // Puedes manejar errores aquí, por ejemplo, mostrar un mensaje al usuario
                });


        })();
    }

    // Función para validar un email
    function isValidEmail(email) {
        // Expresión regular para validar un email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }


})();